<template>
  <div class="drawer">
    <div class="drawer__stage">
      <div
        class="drawer__wrapper"
      >
        <div class="user-settings">
          <div class="user-settings__head">
            <div class="button-group">
              <button
                class="button u-pos-r"
                @click.prevent="$store.dispatch('drawer/close')"
              >
                <i class="icon icon-e-remove" />
              </button>
            </div>
            <div class="avatar avatar--circle">
              <img :src="$page.props.auth.user.avatar">
            </div>
            <div class="data-group data-group--v">
              <span class="data data--highlight">{{ $page.props.auth.user.display_name }}</span>
              <span class="data data--muted">{{ $page.props.auth.user.email }}</span>
            </div>
          </div>
          <div class="user-settings__body">
            <div class="navlinks navlinks--v">
              <div class="navlinks__item">
                <a
                  href=""
                  class="navlinks__link"
                  @click.stop.prevent="openProfileSettingsDrawer"
                >
                  <span class="navlinks__icon">
                    <i class="icon icon-cogwheel" />
                  </span>
                  <span class="navlinks__label">Profile Settings</span>
                </a>
              </div>
              <div class="navlinks__item">
                <a href="" class="navlinks__link">
                  <span class="navlinks__icon">
                    <i class="icon icon-headset" />
                  </span>
                  <span class="navlinks__label">FAQ & Help</span>
                </a>
              </div>
              <div class="navlinks__item">
                <InertiaLink
                  class="navlinks__link"
                  as="button"
                  href="/logout"
                  method="post"
                >
                  <span class="navlinks__icon">
                    <i class="icon icon-leave" />
                  </span>
                  <span class="navlinks__label">Logout</span>
                </InertiaLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainDrawer',
}
</script>
